<div class="row" *ngIf="!loading">
    @let isEmpty = emptyDataMessage.length > 0 && areAllDataRowsEmpty();
    <div class="col-48 position-relative" [style.height.px]="isEmpty ? 'auto' : height">
        <div *ngIf="isEmpty"
             class="charts-overlay">
            <span class="charts-overlay-text">
                {{ emptyDataMessage }}
            </span>
        </div>
        <canvas [attr.height]="height"
                *ngIf="!areAllDataRowsEmpty()"
                class="chart-bar"
                chartBase
                [chartType]="'bar'"
                [chartData]="data"
                [chartLabels]="labels"
                [chartSeries]="series"
                [chartOptions]="options"
                [chartDatasetOverride]="override"
                [chartColors]="colors">
        </canvas>
    </div>
</div>
